import React from "react";
import { Box, Grid, Typography, Paper } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function About() {
  const sectors = [
    "Oil & Gas",
    "Power",
    "Petrochemicals",
    "Refineries",
    "Pipelines",
    "Nuclear Energy",
    "Fertilizers",
    "LNG",
    "Ports & Terminals",
  ];

  return (
    <Box
      component="section"
      id="about"
      sx={{
        backgroundColor: "#F7FAFF",
        py: { xs: 6, md: 10 },
        fontFamily: "Roboto, sans-serif",
      }}
    >
      {/* OUTER CONTAINER */}
      <Box sx={{ px: { xs: 2, sm: 4, md: 6, lg: "250px" } }}>

        {/* TITLE */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            sx={{
              fontSize: { xs: 26, md: 32 },
              fontWeight: 700,
              color: "#2e247c",
              mb: 1,
            }}
          >
            About Us
          </Typography>
          <Box
            sx={{
              width: 90,
              height: 3,
              backgroundColor: "#2e247c",
              mx: "auto",
            }}
          />
        </Box>

        {/* CARD */}
        <Paper
          elevation={2}
          sx={{
            p: { xs: 3, sm: 4, md: 5 },
            borderRadius: "6px",
          }}
        >
          <Grid container spacing={5} alignItems="center">

            {/* IMAGE – FIXED & CONSISTENT */}
           <Grid item xs={12} md={5}>
  <Box
    sx={{
      width: "420px",          // desktop & laptop size
      maxWidth: "100%",
      borderRadius: "2px",
      overflow: "hidden",
      boxShadow: "0 6px 22px rgba(0,0,0,.12)",
      mx: { xs: "auto", md: 0 },
      backgroundColor: "transparent", // ❌ no white box
    }}
  >
    <img
      src="/Building.png"
      alt="Multitex Filters Building"
      style={{
        width: "100%",
        height: "auto",        // ⭐ KEY FIX
        display: "block",
      }}
    />
  </Box>
</Grid>


            {/* CONTENT */}
            <Grid item xs={12} md={7}>
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "18px" },
                  lineHeight: 1.7,
                  color: "#444",
                  mb: 3,
                }}
              >
                Founded in 1980, Multitex Filters Pvt. Ltd. is a reputable name in
                the field of filtration and separation for engineering,
                manufacturing, and customized solutions and multitex is also in possession of various approvals from PSUs like IOCL, HMEL, ONGC and Oil India Limited etc. Our solutions are
                designed for many critical applications across diverse
                industrial sectors.
              </Typography>

              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#2e247c",
                  mb: 2,
                }}
              >
                Industry Sectors We Serve
              </Typography>

              <Grid container spacing={2}>
                {sectors.map((item, i) => (
                  <Grid key={i} item xs={12} sm={6} md={4}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CheckCircleIcon
                        sx={{ fontSize: 18, color: "#2e247c" }}
                      />
                      <Typography sx={{ fontSize: "16px", color: "#333" }}>
                        {item}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>

          </Grid>
        </Paper>
      </Box>
    </Box>
  );
}
